import FetchData from '@shared/utils/fetchData/fetchData';

export const addProductFromComparison = async (products: string[]) => {
  return FetchData.post<{ message: string }>('comparison', {
    body: JSON.stringify({ products })
  });
};
